import { useLeaveUrl } from 'domain/people/leave/leaveRouting';
import { SummaryMenuItem, SidebarStickyMenu } from 'framework/ui/menu';

const ViewLeavePageMenu = () => {
  const { getSingleEntityUrl } = useLeaveUrl();

  return (
    <SidebarStickyMenu>
      <SummaryMenuItem linkUrl={getSingleEntityUrl()} exact />
    </SidebarStickyMenu>
  );
};

export default ViewLeavePageMenu;
